"use strict";
// NOTE: This code was generated and should not be changed
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMarketingResourceComponentViewNonAuth = void 0;
/**
 * A builder for MarketingResourceComponentViewNonAuth
 *
 * @param data - The event data
 * @return The formatted event data for MarketingResourceComponentViewNonAuthEvent
 */
function createMarketingResourceComponentViewNonAuth(data) {
    return {
        name: 'MarketingResourceComponentViewNonAuth',
        environments: ['browsernonauth'],
        data: data,
    };
}
exports.createMarketingResourceComponentViewNonAuth = createMarketingResourceComponentViewNonAuth;
//# sourceMappingURL=createMarketingResourceComponentViewNonAuth.js.map